<div class="equipment-icon-container">
  <app-indicator-text [text]="''+amount" size40="true"></app-indicator-text>
  <i class="demo-icon equipment-icon {{class}}"></i>
</div>
